import React from 'react';
import React3 from 'react-three-renderer';
import * as THREE from 'three';
import { timingSafeEqual } from 'crypto';
const InstancedMesh = require('../instanced')(THREE); //should replace shaders on first call

export default class Rack extends React.Component {
  state = {
    positions: [new THREE.Vector3(0, 0, 0)],
    bbox: new THREE.Box3()
  };
  getScene = (element) => {
    if (element.parent) {
      return this.getScene(element.parent);
    } else {
      return element;
    }
  };
  componentWillUpdate() {
    this.removeObjects();
  }
  componentWillUnmount() {
    this.removeObjects();
  }
  removeObjects = () => {
    // if (this.parentObject) {
    //   const scene = this.getScene(this.parentObject);
    //   this.parentObject.children.forEach((d, i) => {
    //     if (i !== 0) {
    //       d.children.forEach((e, j) => {
    //         // if (j !== 0) {
    //         d.remove(e);
    //         e.geometry.dispose();
    //         e.material.dispose();
    //         e = undefined;
    //         console.log(e);
    //         // }
    //       });
    //       this.parentObject.remove(d);
    //       console.log(d);
    //     }
    //   });
    // }
  };
  componentDidMount() {
    this.removeObjects();
    this.replaceObjects();
  }

  instanceGeometry = () => {
    this.parentObject.children = [];
    const {
      flip,
      scaleLength,
      geometry: { vertices, faceVertexUvs, faces },
      isRack
    } = this.props;
    const { positions } = this.props;
    const geo = { vertices, faceVertexUvs, faces };
    const rotate = this.props.rotate ? Math.PI / 2 : 0;
    const geometry = new THREE.Geometry();

    geometry.faces = faces;
    geometry.vertices = vertices;
    geometry.faceVertexUvs = faceVertexUvs;

    const material = new THREE.MeshLambertMaterial();

    const mat = isRack
      ? // ? new THREE.MeshStandardMaterial({
        //     color: 0x000000,
        //     side: THREE.DoubleSide,
        //     metalness: 0.9,
        //     roughness: 0.2
        //   })
        new THREE.MeshPhongMaterial({
          color: 0x000000,
          side: THREE.DoubleSide,
          // metal: true,
          shininess: 10,
          specular: 0x4682b4
        })
      : new THREE.MeshPhongMaterial({
          color: 0x000000,
          side: THREE.DoubleSide,
          // metal: true,
          shininess: 10,
          specular: 0xffffff
        });

    const bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);
    const rotation = flip
      ? new THREE.Euler(0, Math.PI + rotate, 0)
      : new THREE.Euler(0, rotate, 0);

    const cluster = new InstancedMesh(
      bufferGeometry,
      mat,
      positions.length,
      false,
      false,
      true
    );

    const v = new THREE.Vector3();

    for (var i = 0; i < positions.length; i++) {
      const position = positions[i];
      let quaternion = new THREE.Quaternion().setFromEuler(rotation);

      cluster.setQuaternionAt(i, quaternion);
      cluster.setPositionAt(i, positions[i]);
      cluster.setScaleAt(i, v.set(1, 1, 1));
    }
    cluster.castShadow = true;
    cluster.receiveShadow = true;

    this.parentObject.add(cluster);
    this.props.render();
  };

  componentWillReceiveProps() {
    // this.removeObjects();
  }

  componentDidUpdate(prevProps) {
    const { rows, columns, geometry, positions } = this.props;
    this.instanceGeometry();

    if (prevProps.positions !== this.props.positions) {
      // this.replaceObjects();
    }
    if (geometry !== prevProps.geometry) {
      geometry.computeBoundingBox();
      this.setState({ bbox: geometry.boundingBox });
    }
    if (rows !== prevProps.rows || columns !== prevProps.columns) {
      this.props.actions.referencePoints(this.state.bbox);
    }
    // this.props.render && this.props.render();
  }
  replaceObjects = () => {
    const { rows, columns, geometry, positions } = this.props;

    if (this.rack && positions.length && this.parentObject) {
      const scene = this.getScene(this.rack);
      positions.forEach((p, i) => {
        if (i !== 0) {
          if (Object.keys(p).length === 3) {
            const objectClone = this.rack.clone();
            objectClone.position.set(p.x, p.y, p.z);
            this.parentObject.add(objectClone);
          }
        }
      });
    }
    // this.props.render && this.props.render();
  };

  render() {
    const {
      flip,
      scaleLength,
      configuration,
      geometry: { vertices, faceVertexUvs, faces }
    } = this.props;
    const { positions } = this.props;
    const geo = { vertices, faceVertexUvs, faces };
    const rotate = this.props.rotate ? Math.PI / 2 : 0;

    return (
      <object3D
        frustumCulled
        ref={(node) => {
          this.parentObject = node;
        }}
        key={positions[0] + positions.length + configuration}
      >
        {/* {positions.length ? (
          <object3D
            frustumCulled
            position={positions[0]}
            scale={new THREE.Vector3(scaleLength || 1, 1, 1)}
            rotation={
              flip
                ? new THREE.Euler(0, Math.PI + rotate, 0)
                : new THREE.Euler(0, rotate, 0)
            }
            ref={(node) => {
              this.rack = node;
            }}
          >
            <mesh castShadow receiveShadow>
              <geometry {...geo} />
              <meshStandardMaterial
                color={0xffffff}
                side={THREE.DoubleSide}
                metalness={0.9}
                roughness={0.2}
              />
            </mesh>
          </object3D>
        ) : null} */}
      </object3D>
    );
  }
}

Rack.defaultProps = {
  geometry: new THREE.Geometry()
};



// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/Rack/index.js